import type { FeatureFaqItem } from '@/types/features'

interface FeatureFaqProps {
  faq: FeatureFaqItem[]
  heading?: string
}

// Visible HTML on purpose: no accordion, no scroll-reveal, so every answer is
// readable (and crawlable) without interaction.
export default function FeatureFaq({ faq, heading = 'Frequently asked questions' }: FeatureFaqProps) {
  return (
    <section className="marketing-section">
      <div className="container mx-auto px-6">
        <h2 className="marketing-section-title">{heading}</h2>
        <div className="mt-8 grid gap-6 md:grid-cols-2">
          {faq.map((item) => (
            <div key={item.question} className="marketing-surface-card">
              <h3 className="text-lg font-semibold text-white">{item.question}</h3>
              <p className="mt-3 text-sm leading-7 text-white/72">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
